import useApi from "./useAPI";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router";

export default function useProfile() {
    const { email, updateUserStatus, logout, updateHospitalID } = useAuth();
    const { callApi } = useApi();
    const navigate = useNavigate();

    const checkProfileStatus = async (readOnly = false) => {
        if (!email) return;

        try {
            const result = await callApi({
                url: `${process.env.REACT_APP_BACKEND_ENDPOINT}/doctor/getDoctor?email=${email}`,
                method: "GET",
            });

            const doctor = result.data;

            updateHospitalID(doctor.hospital_id);

            if (!doctor) return null;

            if (readOnly===true){
                return doctor;
            }

            if (doctor.status === "IN_REVIEW") {
                updateUserStatus("IN_REVIEW");
                navigate("/profilepending");
            } else if (doctor.status === "VERIFIED") {
                updateUserStatus("VERIFIED");
                navigate("/dashboard");
            } else if (doctor.status === "PENDING") {
                updateUserStatus("PENDING");
                navigate("/profileform");
            } else {
                logout();
            }

            return doctor;
        } catch (err) {
            console.error("Profile check failed", err);
        }
    };

    return { checkProfileStatus };
}
